import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import './PhysGiftsSection.css';

const PhysGiftsSection = () => {
  return (
    <div className='app__about-gift'>
      <div className='app__about-gift-text'>
        <h2>Tarjeta de regalo.</h2>
        <p>Skincare cuidadosamente elaborado y seleccionado para obsequiar a esa persona tan especial, obsequia la base de una piel saludable y radiante.</p>
        <button type='button' className='app__about-gift-btn'>
          Explora nuestra selección <span><BsArrowRight/></span>
        </button>
      </div>
      <div style={{ width: '40%', height: '300px', alignItems: 'center', justifyContent: 'center' }}>
        <img src="/card.png" alt='Gift products' style={{ width: '420px', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}/>
      </div>
    </div>
  );
};

export default PhysGiftsSection;